'use client'

import Image from 'next/image'
import { cn } from '@/lib/utils'
import { LinkButton } from '@/components/ui/button'

interface HeroVisualProps {
  src: string
  srcMobile?: string
  alt: string
  priority?: boolean
  className?: string
  animation?: 'reveal' | 'parallax' | 'ken-burns' | 'none'
  caption?: string
  captionClassName?: string
  variant?: 'full' | 'contained' | 'narrow'
  ctaText?: string
  ctaHref?: string
}

export default function HeroVisual({
  src,
  srcMobile,
  alt,
  priority = false,
  className,
  animation = 'none',
  caption,
  captionClassName,
  variant = 'full',
  ctaText,
  ctaHref,
}: HeroVisualProps) {
  return (
    <figure
      className={cn(
        'relative mb-8',
        variant === 'full' && 'w-full',
        variant === 'contained' && 'w-full max-w-6xl mx-auto',
        variant === 'narrow' && 'w-full max-w-4xl mx-auto',
        className
      )}
    >
      <div
        className={cn(
          'relative w-full',
          animation === 'reveal' && 'rounded-sm'
        )}
      >
        {/* Desktop Image */}
        <Image
          src={src}
          alt={alt}
          width={1920}
          height={960}
          priority={priority}
          className={cn('w-full h-auto', srcMobile && 'hidden md:block')}
          sizes='100vw'
          quality={95}
        />
        {/* Mobile Image */}
        {srcMobile && (
          <Image
            src={srcMobile}
            alt={alt}
            width={800}
            height={800}
            priority={priority}
            className='w-full h-auto md:hidden'
            sizes='100vw'
            quality={95}
          />
        )}
      </div>
      {(caption || ctaText) && (
        <figcaption
          className={cn(
            'mt-4 text-center max-w-6xl mx-auto px-4',
            captionClassName
          )}
        >
          {caption && (
            <p className='text-sm text-muted-foreground'>{caption}</p>
          )}
          {ctaText && ctaHref && (
            <LinkButton
              href={ctaHref}
              variant='outline'
              size='default'
              className='mt-4'
            >
              {ctaText}
            </LinkButton>
          )}
        </figcaption>
      )}
    </figure>
  )
}
